import { SearchResults } from "../../Shared/scriptts/interfaces";
import { params, executeSearchUrl, displayResults } from '../search-main';

const countIcon = document.createElement('span');

/**
 * Display remote filter
 * @param data The data returned from the search API
 */
export function displayRemoteFilters(data: SearchResults) {
    setFilterCounts(data);
    document.querySelector<HTMLButtonElement>('#remote-reset')?.addEventListener('click', remoteResetClicked);
    document.querySelectorAll<HTMLInputElement>('[name=remote]').forEach(input => {
        input.addEventListener('change', filterItemChanged);
        input.checked = (input.value === 'true' && (params.RemoteIndicator === true || params.RemoteIndicator === 'true'))
            || (input.value === 'false' && (params.RemoteIndicator === false || params.RemoteIndicator === 'false'));
    });
    const titleElem = document.querySelector<HTMLElement>('#titleaccordion-remote');
    if (titleElem === null) {
        return;
    }
    countIcon.id = 'count-remote';
    countIcon.className = 'bg-warning rounded-full py-1 px-2 ml-2';
    if (!titleElem.contains(countIcon)) {
        titleElem.appendChild(countIcon);
    }
    setCountIconDisplay();
}

function remoteResetClicked() {
    params.RemoteIndicator = null;
    params.Page = '1';
    document.querySelectorAll<HTMLInputElement>(`[name=remote]`).forEach(input => {
        input.checked = false;
    });

    displayResults(executeSearchUrl, false, true);
    setCountIconDisplay();
}

function filterItemChanged(evt: Event) {
    const elem = <HTMLInputElement>(evt.target);

    if (elem.checked && elem.value === 'true') {
        params.RemoteIndicator = true;
    }
    else if (elem.checked && elem.value === 'false') {
        params.RemoteIndicator = false;
    }
    else {
        params.RemoteIndicator = null;
    }

    params.Page = '1';
    displayResults(executeSearchUrl, false, true);
    setCountIconDisplay();
}

function setCountIconDisplay() {
    if (params.RemoteIndicator === undefined || params.RemoteIndicator === null || params.RemoteIndicator.toString() === '') {
        countIcon.innerText = ''
        countIcon.classList.add('hidden');
    }
    else {
        countIcon.innerText = '1';
        countIcon.classList.remove('hidden');
    }
}

function setFilterCounts(data: SearchResults) {
    const remoteOnly = document.querySelector<HTMLElement>('#item-count-remote-true');
    const noRemote = document.querySelector<HTMLElement>('#item-count-remote-false');

    if (!remoteOnly || !noRemote) {
        return;
    }

    remoteOnly.innerText = `(${data.f.rmi[1] ?? 0})`;
    noRemote.innerText = `(${data.f.rmi[0] ?? 0})`;
}
